/* eslint frontbucket-patterns/no-new-sagas: "warn" */
import { all } from 'redux-saga/effects';

import filterFiles from './filter-files';
import loadFile from './load-file';
import loadFileTreeSagas from './load-file-tree-saga';
import loadSourceObjectSagas from './load-source-object-saga';

// eslint-disable-next-line import/no-default-export
export default function* sourceSagas() {
  yield all([
    filterFiles(),
    loadFile(),
    loadFileTreeSagas(),
    loadSourceObjectSagas(),
  ]);
}
